import { render, staticRenderFns } from "./ColourPicker.vue?vue&type=template&id=150e070b&"
import script from "./ColourPicker.vue?vue&type=script&lang=js&"
export * from "./ColourPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports